import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui';

/**
 * Branded 404 / not-found screen. Renders inside AppLayout (Climb header + logo),
 * used for unknown routes and for invalid/expired report links.
 */
export function NotFound({
  title = 'Page not found',
  message = "The page you're looking for doesn't exist or may have moved.",
}: {
  title?: string;
  message?: string;
} = {}) {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-xl py-20 text-center">
      <div className="font-display text-7xl font-medium text-climb-cyan">404</div>
      <h1 className="mt-5 text-3xl font-medium text-climb-paper">{title}</h1>
      <p className="mt-3 text-climb-teal-soft">{message}</p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Button onClick={() => navigate('/')}>Back to reviews</Button>
        <a
          href="https://climb.ai"
          className="rounded-lg border border-climb-teal-soft/50 px-5 py-2.5 font-medium text-climb-paper transition hover:border-climb-cyan hover:text-climb-cyan"
        >
          Go to climb.ai
        </a>
      </div>
    </div>
  );
}
